module.exports = __webpack_public_path__ + "static/media/delete-24px.2eb2ef56.svg";